import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, FormGroup, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer'
import { entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';

export default class ModalContent extends Component {
    initModalContent = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null, //guid
            content: null,  //string 
            createdOn: null,
        }
    }

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            model: {
                ...this.initModalContent(props)
            }
        };
    }

    save = () => {
        if (this.validator.allValid()) {
            this.props.save(this.state.model);
            showNotification.success(`${entitiesLabels.SUCCESS}`, "Content created successfully");
        } else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.TRAINING + " required fields are missing  ");
            this.forceUpdate();
        }
    }

    handleChangeContent = (el) => {
        let statusCopy = Object.assign({}, this.state);
        statusCopy.model.content = el.target.value;

        this.setState(statusCopy);
    }

    render() {
        const validations = {
            content: this.validator.message('Content', this.state.model.content, 'required'),
        }

        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;

        return (
            <ComposedModal
                className="light-modal"
                open={isOpenModal}
                danger="false"
                onClose={() => { return false; }}
            >
                <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                <ModalBody className="margin-modal">
                    <div className="bx--grid--full-width">
                        <div className="bx--row row-content">
                            <div className="bx--col-lg-12">
                                <FormGroup legendText="Content">
                                    <TextArea
                                        id="content"
                                        maxLength={5000}
                                        placeholder="Input content (max 5000 characters)"
                                        value={this.state.model.content || ''}
                                        onChange={this.handleChangeContent}
                                        hideLabel={true}
                                        labelText=""
                                        light
                                        rows={6}
                                        cols={100}
                                        invalid={validations.content != null}
                                        invalidText={validations.content}
                                        title={this.props.titleAlert ?? null}
                                    />
                                </FormGroup>

                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                    <Button kind='primary' onClick={() => this.save()}>Save</Button>
                </ModalFooter>
            </ComposedModal>
        );
    }
}

ModalContent.propTypes = {
    save: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isEditModal: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    title: PropTypes.string,
};